import React, { useState, useImperativeHandle, forwardRef, useCallback } from "react";

//css
import "./ScrollToTop.scoped.scss";
import useEventListener from "hooks/useEventListener";

const ScrollToTop = forwardRef((props, ref) => {
	const [isVisible, setIsVisible] = useState(false);
	const [currWindowHeight, setCurrWindowHeight] = useState(0);

	const toggleVisibility = useCallback(
		() => (window.scrollTop > 300 && !(window.scrollTop > currWindowHeight) ? setIsVisible(true) : setIsVisible(false)),
		[currWindowHeight]
	);

	const scrollToTop = () => {
		document.dispatchEvent(new CustomEvent("restoreGlobalScroll", { detail: { scrollTop: 0, smoothScroll: true } }));
		toggleVisibility();
	};

	useEventListener(document, "onGlobalScroll", toggleVisibility);
	useImperativeHandle(ref, () => ({ onWindowHeightChange: windowHeight => setCurrWindowHeight(windowHeight) }));

	return (
		<button className={!isVisible ? "hidden" : ""} onClick={scrollToTop}>
			<i className="fas fa-arrow-up" />
		</button>
	);
});

export default ScrollToTop;
